import textureBackgrounds from './textureBackgrounds';

// 导入unsplash图片
import photo1 from '@assets/unsplash/photo-1579546929518-9e396f3cc809.jpeg';
import photo2 from '@assets/unsplash/photo-1579548122080-c35fd6820ecb.jpeg';
import photo3 from '@assets/unsplash/photo-1558470598-a5dda9640f68.jpeg';
import photo4 from '@assets/unsplash/photo-1533134486753-c833f0ed4866.jpeg';
import photo5 from '@assets/unsplash/photo-1559251606-c623743a6d76.jpeg';
import photo6 from '@assets/unsplash/photo-1566228015668-4c45dbc4e2f5.jpeg';
import photo7 from '@assets/unsplash/photo-1557683316-973673baf926.jpeg';
import photo8 from '@assets/unsplash/photo-1579546929662-711aa81148cf.jpeg';
import photo9 from '@assets/unsplash/photo-1498050108023-c5249f4df085.avif';
import photo10 from '@assets/unsplash/photo-1554110397-9bac083977c6.avif';
import photo11 from '@assets/unsplash/photo-1671180881490-8af6e9c3eaf1.avif';
import photo12 from '@assets/unsplash/photo-1671549296089-88b3a6eb347e.avif';
import photo13 from '@assets/unsplash/photo-1668718031554-9c05b5d03750.avif';
import photo14 from '@assets/unsplash/photo-1555099962-4199c345e5dd.jpeg';
import photo15 from '@assets/unsplash/photo-1517694712202-14dd9538aa97.jpeg';
import photo16 from '@assets/unsplash/photo-1531297484001-80022131f5a1.jpeg';
import photo17 from '@assets/unsplash/photo-1620121692029-d088224ddc74.jpeg';
import photo18 from '@assets/unsplash/photo-1541462608143-67571c6738dd.jpeg';
import photo19 from '@assets/unsplash/photo-1550745165-9bc0b252726f.jpeg';
import photo20 from '@assets/unsplash/photo-1484417894907-623942c8ee29.jpeg';

const staticBackgrounds = {
    default_1: {
        class: 'bg-gradient-to-r from-indigo-500 via-purple-500 to-pink-500',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#6366f1', '#a855f7', '#ec4899'],
        },
    },
    default_2: {
        class: 'bg-gradient-to-r from-red-500 via-pink-500 to-violet-500',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#ef4444', '#ec4899', '#8b5cf6'],
        },
    },
    default_3: {
        class: 'bg-gradient-to-r from-violet-800 via-pink-600 to-orange-500',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#5b21b6', '#db2777', '#f97316'],
        },
    },
    default_4: {
        class: 'bg-gradient-to-r from-orange-400 to-rose-400',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#fb923c', '#fb7185'],
        },
    },
    default_5: {
        class: 'bg-gradient-to-r from-[#4284DB] to-[#29EAC4]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#4284DB', '#29EAC4'],
        },
    },
    default_6: {
        class: 'bg-gradient-to-r from-[#fc00ff] to-[#00dbde]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#fc00ff', '#00dbde'],
        },
    },
    default_7: {
        class: 'bg-gradient-to-br from-[#eeddf3] via-[#ee92b1] to-[#6330b4]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#eeddf3', '#ee92b1', '#6330b4'],
        },
    },
    default_8: {
        class: 'bg-gradient-to-r from-[#8360c3] to-[#2ebf91]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#8360c3', '#2ebf91'],
        },
    },
    default_9: {
        class: 'bg-gradient-to-r from-[#3a1c71] via-[#d76d77] to-[#ffaf7b]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#3a1c71', '#d76d77', '#ffaf7b'],
        },
    },
    default_10: {
        class: 'bg-gradient-to-r from-[#4facfe] to-[#00f2fe]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#4facfe', '#00f2fe'],
        },
    },
    default_11: {
        class: 'bg-gradient-to-r from-[#2af598] to-[#009efd]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#2af598', '#009efd'],
        },
    },
    solid_1: {
        class: 'bg-transparent',
        fill: {
            type: 'solid',
            color: '#ffffff00',
        },
    },
    solid_2: {
        class: 'bg-slate-400',
        fill: {
            type: 'solid',
            color: '#94a3b8',
        },
    },
    solid_3: {
        class: 'bg-gray-400',
        fill: {
            type: 'solid',
            color: '#9ca3af',
        },
    },
    solid_4: {
        class: 'bg-stone-400',
        fill: {
            type: 'solid',
            color: '#a8a29e',
        },
    },
    solid_5: {
        class: 'bg-red-400',
        fill: {
            type: 'solid',
            color: '#f87171',
        },
    },
    solid_6: {
        class: 'bg-orange-400',
        fill: {
            type: 'solid',
            color: '#fb923c',
        },
    },
    solid_7: {
        class: 'bg-amber-400',
        fill: {
            type: 'solid',
            color: '#facc15',
        },
    },
    solid_8: {
        class: 'bg-yellow-400',
        fill: {
            type: 'solid',
            color: '#fbbf24',
        },
    },
    solid_9: {
        class: 'bg-lime-400',
        fill: {
            type: 'solid',
            color: '#a3e635',
        },
    },
    solid_10: {
        class: 'bg-green-400',
        fill: {
            type: 'solid',
            color: '#4ade80',
        },
    },
    solid_11: {
        class: 'bg-emerald-400',
        fill: {
            type: 'solid',
            color: '#34d399',
        },
    },
    solid_12: {
        class: 'bg-teal-400',
        fill: {
            type: 'solid',
            color: '#2dd4bf',
        },
    },
    solid_13: {
        class: 'bg-cyan-400',
        fill: {
            type: 'solid',
            color: '#22d3ee',
        },
    },
    solid_14: {
        class: 'bg-sky-400',
        fill: {
            type: 'solid',
            color: '#38bdf8',
        },
    },
    solid_15: {
        class: 'bg-blue-400',
        fill: {
            type: 'solid',
            color: '#60a5fa',
        },
    },
    solid_16: {
        class: 'bg-indigo-400',
        fill: {
            type: 'solid',
            color: '#818cf8',
        },
    },
    solid_17: {
        class: 'bg-violet-400',
        fill: {
            type: 'solid',
            color: '#a78bfa',
        },
    },
    solid_18: {
        class: 'bg-purple-400',
        fill: {
            type: 'solid',
            color: '#c084fc',
        },
    },
    solid_19: {
        class: 'bg-fuchsia-400',
        fill: {
            type: 'solid',
            color: '#e879f9',
        },
    },
    solid_20: {
        class: 'bg-pink-400',
        fill: {
            type: 'solid',
            color: '#f472b6',
        },
    },
    solid_21: {
        class: 'bg-rose-400',
        fill: {
            type: 'solid',
            color: '#fb7185',
        },
    },
    solid_22: {
        class: 'bg-slate-800',
        fill: {
            type: 'solid',
            color: '#1e293b',
        },
    },
    solid_23: {
        class: 'bg-red-800',
        fill: {
            type: 'solid',
            color: '#991b1b',
        },
    },
    solid_24: {
        class: 'bg-orange-800',
        fill: {
            type: 'solid',
            color: '#9a3412',
        },
    },
    solid_25: {
        class: 'bg-amber-800',
        fill: {
            type: 'solid',
            color: '#92400e',
        },
    },
    solid_26: {
        class: 'bg-yellow-800',
        fill: {
            type: 'solid',
            color: '#854d0e',
        },
    },
    solid_27: {
        class: 'bg-lime-800',
        fill: {
            type: 'solid',
            color: '#3f6212',
        },
    },
    solid_28: {
        class: 'bg-green-800',
        fill: {
            type: 'solid',
            color: '#166534',
        },
    },
    solid_29: {
        class: 'bg-emerald-800',
        fill: {
            type: 'solid',
            color: '#065f46',
        },
    },
    solid_30: {
        class: 'bg-teal-800',
        fill: {
            type: 'solid',
            color: '#115e59',
        },
    },
    solid_31: {
        class: 'bg-cyan-800',
        fill: {
            type: 'solid',
            color: '#155e75',
        },
    },
    solid_32: {
        class: 'bg-sky-800',
        fill: {
            type: 'solid',
            color: '#075985',
        },
    },
    solid_33: {
        class: 'bg-blue-800',
        fill: {
            type: 'solid',
            color: '#1e40af',
        },
    },
    solid_34: {
        class: 'bg-indigo-800',
        fill: {
            type: 'solid',
            color: '#3730a3',
        },
    },
    solid_35: {
        class: 'bg-violet-800',
        fill: {
            type: 'solid',
            color: '#5b21b6',
        },
    },
    gradient_1: {
        class: 'bg-gradient-to-br from-[#ff6432] from-12.8% via-[#ff0065] via-43.52% to-[#7b2eff] to-84.34%',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: [
                { offset: 0.12, color: '#ff6432' },
                { offset: 0.44, color: '#ff0065' },
                { offset: 0.84, color: '#7b2eff' },
            ],
        },
    },
    gradient_2: {
        class: 'bg-gradient-to-br from-[#69eacb] from-0% via-[#eaccf8] via-48% to-[#6654f1] to-100%',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: [
                { offset: 0, color: '#69eacb' },
                { offset: 0.48, color: '#eaccf8' },
                { offset: 1, color: '#6654f1' },
            ],
        },
    },
    gradient_3: {
        class: 'bg-gradient-to-br from-[#f9f047] to-[#0fd850]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#f9f047', '#0fd850'],
        },
    },
    gradient_4: {
        class: 'bg-gradient-to-br from-[#ffcc2f] to-[#ef5734]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#ffcc2f', '#ef5734'],
        },
    },
    gradient_5: {
        class: 'bg-gradient-to-br from-[#00c6ff] to-[#0072ff]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#00c6ff', '#0072ff'],
        },
    },
    gradient_6: {
        class: 'bg-gradient-to-br from-[#f857a6] to-[#ff5858]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#f857a6', '#ff5858'],
        },
    },
    gradient_7: {
        class: 'bg-gradient-to-br from-[#20bdff] to-[#a5fecb]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#20bdff', '#a5fecb'],
        },
    },
    gradient_8: {
        class: 'bg-gradient-to-br from-[#4158D0] via-[#C850C0] to-[#FFCC70]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#4158D0', '#C850C0', '#FFCC70'],
        },
    },
    gradient_9: {
        class: 'bg-gradient-to-br from-[#0093E9] to-[#80D0C7]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#0093E9', '#80D0C7'],
        },
    },
    gradient_10: {
        class: 'bg-gradient-to-br from-[#8EC5FC] to-[#E0C3FC]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#8EC5FC', '#E0C3FC'],
        },
    },
    gradient_11: {
        class: 'bg-gradient-to-br from-[#D9AFD9] to-[#97D9E1]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#D9AFD9', '#97D9E1'],
        },
    },
    gradient_12: {
        class: 'bg-gradient-to-br from-[#FEE140] to-[#FA709A]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#FEE140', '#FA709A'],
        },
    },
    gradient_13: {
        class: 'bg-gradient-to-br from-[#FF9A9E] to-[#FECFEF]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#FF9A9E', '#FECFEF'],
        },
    },
    gradient_14: {
        class: 'bg-gradient-to-br from-[#F6D365] to-[#FDA085]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#F6D365', '#FDA085'],
        },
    },
    gradient_15: {
        class: 'bg-gradient-to-br from-[#5EE7DF] to-[#B490CA]',
        fill: {
            type: 'linear',
            from: 'top-left',
            to: 'bottom-right',
            stops: ['#5EE7DF', '#B490CA'],
        },
    },
    gradient_16: {
        class: 'bg-gradient-to-r from-[#30CFD0] to-[#330867]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#30CFD0', '#330867'],
        },
    },
    gradient_17: {
        class: 'bg-gradient-to-r from-[#A8EDEA] to-[#FED6E3]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#A8EDEA', '#FED6E3'],
        },
    },
    gradient_18: {
        class: 'bg-gradient-to-r from-[#FDDB92] to-[#D1FDFF]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#FDDB92', '#D1FDFF'],
        },
    },
    gradient_19: {
        class: 'bg-gradient-to-r from-[#9890E3] to-[#B1F4CF]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#9890E3', '#B1F4CF'],
        },
    },
    gradient_20: {
        class: 'bg-gradient-to-r from-[#96E6A1] to-[#D4FC79]',
        fill: {
            type: 'linear',
            from: 'left',
            to: 'right',
            stops: ['#96E6A1', '#D4FC79'],
        },
    },
    gradient_21: {
        class: 'bg-gradient-to-t from-[#E2B0FF] to-[#9F44D3]',
        fill: {
            type: 'linear',
            from: 'bottom',
            to: 'top',
            stops: ['#E2B0FF', '#9F44D3'],
        },
    },
    gradient_22: {
        class: 'bg-gradient-to-t from-[#F05F57] to-[#360940]',
        fill: {
            type: 'linear',
            from: 'bottom',
            to: 'top',
            stops: ['#F05F57', '#360940'],
        },
    },
    gradient_23: {
        class: 'bg-gradient-to-t from-[#2AFADF] to-[#4C83FF]',
        fill: {
            type: 'linear',
            from: 'bottom',
            to: 'top',
            stops: ['#2AFADF', '#4C83FF'],
        },
    },
    gradient_24: {
        class: 'bg-gradient-to-t from-[#FFF720] to-[#3CD500]',
        fill: {
            type: 'linear',
            from: 'bottom',
            to: 'top',
            stops: ['#FFF720', '#3CD500'],
        },
    },
    gradient_25: {
        class: 'bg-gradient-to-bl from-[#FF4E50] to-[#F9D423]',
        fill: {
            type: 'linear',
            from: 'top-right',
            to: 'bottom-left',
            stops: ['#FF4E50', '#F9D423'],
        },
    },
    gradient_26: {
        class: 'bg-gradient-to-bl from-[#7028E4] to-[#E5B2CA]',
        fill: {
            type: 'linear',
            from: 'top-right',
            to: 'bottom-left',
            stops: ['#7028E4', '#E5B2CA'],
        },
    },
    gradient_27: {
        class: 'bg-gradient-to-bl from-[#77A1D3] via-[#79CBCA] to-[#E684AE]',
        fill: {
            type: 'linear',
            from: 'top-right',
            to: 'bottom-left',
            stops: ['#77A1D3', '#79CBCA', '#E684AE'],
        },
    },
    gradient_28: {
        class: 'bg-gradient-to-bl from-[#13547A] to-[#80D0C7]',
        fill: {
            type: 'linear',
            from: 'top-right',
            to: 'bottom-left',
            stops: ['#13547A', '#80D0C7'],
        },
    },
    recommend_img_1: {
        class: photo1,
        fill: {
            type: 'image',
            url: photo1
        }
    },
    recommend_img_2: {
        class: photo2,
        fill: {
            type: 'image',
            url: photo2
        }
    },
    recommend_img_3: {
        class: photo3,
        fill: {
            type: 'image',
            url: photo3
        }
    },
    recommend_img_4: {
        class: photo4,
        fill: {
            type: 'image',
            url: photo4
        }
    },
    recommend_img_5: {
        class: photo5,
        fill: {
            type: 'image',
            url: photo5
        }
    },
    recommend_img_6: {
        class: photo6,
        fill: {
            type: 'image',
            url: photo6
        }
    },
    recommend_img_7: {
        class: photo7,
        fill: {
            type: 'image',
            url: photo7
        }
    },
    recommend_img_8: {
        class: photo8,
        fill: {
            type: 'image',
            url: photo8
        }
    },
    recommend_img_9: {
        class: photo9,
        fill: {
            type: 'image',
            url: photo9
        }
    },
    recommend_img_10: {
        class: photo10,
        fill: {
            type: 'image',
            url: photo10
        }
    },
    recommend_img_11: {
        class: photo11,
        fill: {
            type: 'image',
            url: photo11
        }
    },
    recommend_img_12: {
        class: photo12,
        fill: {
            type: 'image',
            url: photo12
        }
    },
    recommend_img_13: {
        class: photo13,
        fill: {
            type: 'image',
            url: photo13
        }
    },
    recommend_img_14: {
        class: photo14,
        fill: {
            type: 'image',
            url: photo14
        }
    },
    recommend_img_15: {
        class: photo15,
        fill: {
            type: 'image',
            url: photo15
        }
    },
    recommend_img_16: {
        class: photo16,
        fill: {
            type: 'image',
            url: photo16
        }
    },
    recommend_img_17: {
        class: photo17,
        fill: {
            type: 'image',
            url: photo17
        }
    },
    recommend_img_18: {
        class: photo18,
        fill: {
            type: 'image',
            url: photo18
        }
    },
    recommend_img_19: {
        class: photo19,
        fill: {
            type: 'image',
            url: photo19
        }
    },
    recommend_img_20: {
        class: photo20,
        fill: {
            type: 'image',
            url: photo20
        }
    },
};

// 合并静态背景和纹理背景
export default {
    ...staticBackgrounds,
    ...textureBackgrounds,
};
